export default __webpack_public_path__ + "total-module-light-icon.svg";